import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'kk',
  Pagination: {
    items_per_page: '/ бет',
    jump_to: 'Секіру',
    jump_to_confirm: 'Растау',
    page: '',
    prev_page: 'Артқа',
    next_page: 'Алға',
    prev_5: 'Алдыңғы 5',
    next_5: 'Келесі 5',
    prev_3: 'Алдыңғы 3',
    next_3: 'Келесі 3',
  },
  DatePicker: {
    lang: {
      placeholder: 'Күнді таңдаңыз',
      yearPlaceholder: 'Жылды таңдаңыз',
      quarterPlaceholder: 'Тоқсанды таңдаңыз',
      monthPlaceholder: 'Айды таңдаңыз',
      weekPlaceholder: 'Аптаны таңдаңыз',
      rangePlaceholder: [
        'Бастау күні',
        'Аяқталу күні',
      ],
      rangeYearPlaceholder: [
        'Бастау жылы',
        'Аяқталу жылы',
      ],
      rangeMonthPlaceholder: [
        'Бастау айы',
        'Аяқталу айы',
      ],
      rangeWeekPlaceholder: [
        'Бастау апта',
        'Аяқталу апта',
      ],
      locale: 'kk_KZ',
      today: 'Бүгін',
      now: 'Қазір',
      backToToday: 'Ағымдағы күн',
      ok: 'Таңдау',
      clear: 'Таза',
      month: 'Ай',
      year: 'Жыл',
      timeSelect: 'Уақытты таңдау',
      dateSelect: 'Күнді таңдау',
      monthSelect: 'Айды таңдаңыз',
      yearSelect: 'Жылды таңдаңыз',
      decadeSelect: 'Онжылды таңдаңыз',
      yearFormat: 'YYYY',
      dateFormat: 'D-M-YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D-M-YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Алдыңғы ай (PageUp)',
      nextMonth: 'Келесі ай (PageDown)',
      previousYear: 'Алдыңғы жыл (Control + left)',
      nextYear: 'Келесі жыл (Control + right)',
      previousDecade: 'Алдыңғы онжылдық',
      nextDecade: 'Келесі онжылдық',
      previousCentury: 'Алдыңғы ғасыр',
      nextCentury: 'Келесі ғасыр',
    },
    timePickerLocale: {
      placeholder: 'Уақытты таңдаңыз',
      rangePlaceholder: [
        'Бастау уақыты',
        'Аяқталу уақыты',
      ],
    },
  },
  TimePicker: {
    placeholder: 'Уақытты таңдаңыз',
    rangePlaceholder: [
      'Бастау уақыты',
      'Аяқталу уақыты',
    ],
  },
  Calendar: {
    lang: {
      placeholder: 'Күнді таңдаңыз',
      yearPlaceholder: 'Жылды таңдаңыз',
      quarterPlaceholder: 'Тоқсанды таңдаңыз',
      monthPlaceholder: 'Айды таңдаңыз',
      weekPlaceholder: 'Аптаны таңдаңыз',
      rangePlaceholder: [
        'Бастау күні',
        'Аяқталу күні',
      ],
      rangeYearPlaceholder: [
        'Бастау жылы',
        'Аяқталу жылы',
      ],
      rangeMonthPlaceholder: [
        'Бастау айы',
        'Аяқталу айы',
      ],
      rangeWeekPlaceholder: [
        'Бастау апта',
        'Аяқталу апта',
      ],
      locale: 'kk_KZ',
      today: 'Бүгін',
      now: 'Қазір',
      backToToday: 'Ағымдағы күн',
      ok: 'Таңдау',
      clear: 'Таза',
      month: 'Ай',
      year: 'Жыл',
      timeSelect: 'Уақытты таңдау',
      dateSelect: 'Күнді таңдау',
      monthSelect: 'Айды таңдаңыз',
      yearSelect: 'Жылды таңдаңыз',
      decadeSelect: 'Онжылды таңдаңыз',
      yearFormat: 'YYYY',
      dateFormat: 'D-M-YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D-M-YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Алдыңғы ай (PageUp)',
      nextMonth: 'Келесі ай (PageDown)',
      previousYear: 'Алдыңғы жыл (Control + left)',
      nextYear: 'Келесі жыл (Control + right)',
      previousDecade: 'Алдыңғы онжылдық',
      nextDecade: 'Келесі онжылдық',
      previousCentury: 'Алдыңғы ғасыр',
      nextCentury: 'Келесі ғасыр',
    },
    timePickerLocale: {
      placeholder: 'Уақытты таңдаңыз',
      rangePlaceholder: [
        'Бастау уақыты',
        'Аяқталу уақыты',
      ],
    },
  },
  global: {
    placeholder: 'Таңдаңыз',
  },
  Table: {
    filterTitle: 'Фильтр',
    filterConfirm: 'OK',
    filterReset: 'Тазарту',
    filterEmptyText: 'Фильтр жоқ',
    emptyText: 'Деректер жоқ',
    selectAll: 'Барлығын таңдау',
    selectInvert: 'Таңдауды төңкеру',
    selectionAll: 'Барлық деректерді таңдаңыз',
    sortTitle: 'Сұрыптау',
    expand: 'Жолды жазу',
    collapse: 'Жолды бүктеу',
    triggerDesc: 'Төмендеуді сұрыптау үшін басыңыз',
    triggerAsc: 'Өсу ретімен сұрыптау үшін басыңыз',
    cancelSort: 'Сұрыптаудан бас тарту үшін басыңыз',
  },
  Modal: {
    okText: 'Жарайды',
    cancelText: 'Болдырмау',
    justOkText: 'Жарайды',
  },
  Popconfirm: {
    okText: 'Жарайды',
    cancelText: 'Болдырмау',
  },
  Transfer: {
    titles: [
      '',
      '',
    ],
    searchPlaceholder: 'Іздеу',
    itemUnit: 'элемент.',
    itemsUnit: 'элемент.',
    remove: 'Жою',
    selectAll: 'Барлық деректерді таңдау',
    selectCurrent: 'Ағымдағы бетті таңдау',
    selectInvert: 'Кері тәртіпте көрсету',
    removeAll: 'Барлық деректерді жою',
    removeCurrent: 'Ағымдағы парақты өшіру',
  },
  Upload: {
    uploading: 'Жүктеу...',
    removeFile: 'Файлды жою',
    uploadError: 'Жүктеу кезінде қате пайда болды',
    previewFile: 'Файлды алдын ала қарау',
    downloadFile: 'Файлды жүктеу',
  },
  Empty: {
    description: 'Деректер жоқ',
  },
  Icon: {
    icon: 'белгішесі',
  },
  Text: {
    edit: 'Өңдеу',
    copy: 'Көшіру',
    copied: 'Көшірілді',
    expand: 'Жазу',
  },
  PageHeader: {
    back: 'Артқа',
  },
  Form: {
    defaultValidateMessages: {
      default: '${label} өрісін тексеру қателігі',
      required: '${label} енгізіңіз',
      enum: '${label} [${enum}] қатарынан болуы керек',
      whitespace: '${label} бос болмауы керек',
      date: {
        format: '${label} жарамды күн форматы емес',
        parse: '${label} күнге түрлендірілмейді',
        invalid: '${label} жарамды күн емес',
      },
      types: {
        string: '${label} ${type} типі емес',
        method: '${label} ${type} типі емес',
        array: '${label} ${type} типі емес',
        object: '${label} ${type} типі емес',
        number: '${label} ${type} типі емес',
        date: '${label} ${type} типі емес',
        boolean: '${label} ${type} типі емес',
        integer: '${label} ${type} типі емес',
        float: '${label} ${type} типі емес',
        regexp: '${label} ${type} типі емес',
        email: '${label} ${type} типі емес',
        url: '${label} ${type} типі емес',
        hex: '${label} ${type} типі емес',
      },
      string: {
        len: '${label} ${len} таңбадан тұруы керек',
        min: '${label} ${min} таңбадан үлкен немесе оған тең болуы керек',
        max: '${label} ${max} таңбадан кем немесе оған тең болуы керек',
        range: '${label} ұзындығы ${min}-${max} таңба аралығында болуы керек',
      },
      number: {
        len: '${label} ${len} тең болуы керек',
        min: '${label} ${min} мәнінен үлкен немесе оған тең болуы керек',
        max: '${label} ${max} мәнінен аз немесе оған тең болуы керек',
      },
      array: {
        len: '${label} элементтерінің саны ${len} тең болуы керек',
        min: '${label} элементтерінің саны ${min} көп немесе оған тең болуы керек',
        max: '${label} элементтерінің саны ${max} аз немесе оған тең болуы керек',
        range: '${label} элементтерінің саны ${min} - ${max} аралығында болуы керек',
      },
      pattern: {
        mismatch: '${label} ${pattern} мен сәйкес келмейді',
      },
    },
  },
};

export default localeValues;
